import { INVITES_ROLE_LABEL_MAPPING } from 'commons/constants';
import {
  Course,
  CourseCategories,
  CourseModalityEnum,
  GlobalPartner,
  PartnerInstance,
  RoleInterface,
  TermInterface,
} from 'commons/types';
import { GetPaginatedResponseInterface } from 'commons/types/api';

export const modalityOptions = [
  {
    label: 'Online',
    value: CourseModalityEnum.ONLINE,
  },
  {
    label: 'In-Person',
    value: CourseModalityEnum.IN_PERSON,
  },
  {
    label: 'Hybrid',
    value: CourseModalityEnum.HYBRID,
  },
];

export const getTermOptions = (terms: GetPaginatedResponseInterface<TermInterface>) =>
  terms?.data?.map((term) => ({ label: term.name, value: term.id })) || [];

export const getCourseOptions = (courses: GetPaginatedResponseInterface<Course>) =>
  courses?.data?.map((course) => ({ label: course.title, value: course.id })) || [];

export const getPartnerOptions = (partners: GetPaginatedResponseInterface<PartnerInstance>) =>
  partners?.data?.map((partner) => ({ label: partner.name, value: partner.id })) || [];

export const getCourseCategoryOptions = (
  categories: GetPaginatedResponseInterface<CourseCategories>,
) => categories?.data?.map((category) => ({ label: category.name, value: category.id })) || [];

export const getRoleOptions = (roles: RoleInterface[]) =>
  roles
    ?.filter((role) => ['instance-admin', 'instance-member'].includes(role.name))
    .map((role) => ({
      label: INVITES_ROLE_LABEL_MAPPING[role.name],
      value: role.id,
    })) || [];

export const getCourseCodeOptions = (courses: GetPaginatedResponseInterface<Course>) => {
  const filteredCourses = (courses?.data ?? []).filter(
    (course) => course?.courseCode !== null && course?.courseCode !== undefined,
  );
  return filteredCourses.map((course) => ({
    label: course.courseCode,
    value: course.courseCode,
  }));
};

export const configCourseTableFilters = (
  tableFilters: Record<string, any> | [],
  globalPartner: GlobalPartner,
  onlyActiveCourses = false,
) => {
  const defaultCourseTableFilters = [
    {
      or: [
        { field: 'partner_id', op: 'eq', val: globalPartner?.id.toString() },
        {
          field: 'partner.parent_partner_id',
          op: 'eq',
          val: globalPartner?.partnerId,
        },
      ],
    },
  ];

  if (onlyActiveCourses) {
    defaultCourseTableFilters.push({
      // @ts-ignore
      and: [
        { field: 'is_published', op: 'eq', val: true },
        { field: 'is_active', op: 'eq', val: true },
      ],
    });
  }

  if (tableFilters?.length) {
    // Add default partner filters to existing filters,
    // if partner filters are not already present
    const hasPartnerFilter = tableFilters.some(
      (filter) =>
        (filter &&
          'and' in filter &&
          Array.isArray(filter.and) &&
          filter.and.some((condition) => condition.field === 'partner.id')) ||
        (filter &&
          'or' in filter &&
          Array.isArray(filter.or) &&
          filter.or.some(
            (condition) =>
              condition.field === 'partner_id' || condition.field === 'partner.parent_partner_id',
          )),
    );
    if (!hasPartnerFilter) {
      return [...defaultCourseTableFilters, ...(Array.isArray(tableFilters) ? tableFilters : [])];
    }
    return tableFilters;
  }
  return defaultCourseTableFilters;
};
